/**
 * @param {string} id
 * @param {string} latchkey
 * @returns {string}
 */
export function toTraitId(id, latchkey) { // eslint-disable-line import/prefer-default-export
  return `${id}-${latchkey}`;
}

/**
 *
 * @param {Product} productData
 * @param {string} selectedLatchkey
 * @returns {number | undefined}
 */
export function getFirstUpcIdFromSelectedLatchkey(productData, selectedLatchkey) {
  const latchkeyProduct = productData?.relationships?.latchKeyToProductMap?.[selectedLatchkey];
  return Object.values(latchkeyProduct?.traits?.traitsMaps?.upcMap || {})[0];
}
